import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { LearningSession, SessionMessage, CourseDocument } from '../types'

export const sessionsApi = {
  start: (courseId: string) =>
    apiClient.post<ApiResponse<LearningSession>>(`/courses/${courseId}/sessions`),

  get: (sessionId: string) =>
    apiClient.get<ApiResponse<LearningSession>>(`/sessions/${sessionId}`),

  pause: (sessionId: string) =>
    apiClient.patch<ApiResponse<LearningSession>>(`/sessions/${sessionId}/pause`),

  resume: (sessionId: string) =>
    apiClient.patch<ApiResponse<LearningSession>>(`/sessions/${sessionId}/resume`),

  end: (sessionId: string) =>
    apiClient.patch<ApiResponse<LearningSession>>(`/sessions/${sessionId}/end`),

  getMessages: (sessionId: string) =>
    apiClient.get<ApiResponse<SessionMessage[]>>(`/sessions/${sessionId}/messages`),

  sendMessage: (sessionId: string, content: string, messageUuid: string) =>
    apiClient.post<ApiResponse<SessionMessage>>(`/sessions/${sessionId}/messages`, {
      content,
      message_uuid: messageUuid,
    }),

  /**
   * Échange l'authentification Bearer courante (portée par `apiClient`,
   * jamais l'URL) contre un billet de flux à usage unique et de très
   * courte durée de vie. `EventSource` ne sachant poser aucun en-tête,
   * c'est ce billet — et non le jeton d'API durable — qui doit voyager
   * dans l'URL du flux (voir `getStreamUrl`).
   */
  getStreamTicket: (sessionId: string) =>
    apiClient.post<ApiResponse<{ ticket: string; expires_in: number }>>(
      `/sessions/${sessionId}/stream-ticket`,
    ),

  /** Builds the SSE stream URL — EventSource handles the connection directly */
  getStreamUrl: (sessionId: string, content: string, messageUuid: string, ticket: string): string => {
    const params = new URLSearchParams({ ticket, content, message_uuid: messageUuid })
    return `/api/v1/sessions/${sessionId}/stream?${params.toString()}`
  },
}

export async function getDocumentStatus(
  courseId: string,
  documentId: string,
): Promise<CourseDocument> {
  const res = await apiClient.get<ApiResponse<CourseDocument>>(
    `/courses/${courseId}/documents/${documentId}/status`,
  )
  return res.data.data
}

export async function getCourseDocs(courseId: string): Promise<CourseDocument[]> {
  const res = await apiClient.get<ApiResponse<CourseDocument[]>>(
    `/courses/${courseId}/documents`,
  )
  return res.data.data
}
